import AxiosInstance from '../axios/AxiosInstance';

const ficheClientService = {
  /**
   * Valider un token
   * @param {string} token - Le token à valider
   * @returns {Promise} - Informations du client
   */
  async validateToken(token) {
    try {
      const response = await AxiosInstance.get(`/fiche-renseignement-historique/public/validate/${token}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la validation du token:', error);
      throw error;
    }
  },

  /**
   * Soumettre le formulaire avec un token
   * @param {string} token - Le token
   * @param {Object} ficheData - Les données de la fiche client
   * @returns {Promise} - Réponse du serveur
   */
  async submitWithToken(token, ficheData) {
    try {
      const response = await AxiosInstance.post(`/fiche-renseignement-historique/public/submit/${token}`, ficheData);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la soumission de la fiche client:', error);
      console.error('Détails de l\'erreur:', error.response?.data);
      console.error('Status:', error.response?.status);
      console.error('Données envoyées:', ficheData);
      throw error;
    }
  },

  /**
   * Créer une nouvelle fiche client (méthode legacy)
   * @param {Object} ficheData - Les données de la fiche client
   * @returns {Promise} - Réponse du serveur
   */
  async create(ficheData) {
    try {
      const response = await AxiosInstance.post('/fiche-client', ficheData);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la création de la fiche client:', error);
      console.error('Détails de l\'erreur:', error.response?.data);
      console.error('Status:', error.response?.status);
      console.error('Données envoyées:', ficheData);
      throw error;
    }
  },

  /**
   * Récupérer toutes les fiches clients
   * @returns {Promise} - Liste des fiches clients
   */
  async getAll() {
    try {
      const response = await AxiosInstance.get('/fiche-client');
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des fiches clients:', error);
      throw error;
    }
  },

  /**
   * Récupérer une fiche client par ID
   * @param {string} id - ID de la fiche client
   * @returns {Promise} - Fiche client
   */
  async getById(id) {
    try {
      const response = await AxiosInstance.get(`/fiche-client/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération de la fiche client:', error);
      throw error;
    }
  },

  /**
   * Mettre à jour une fiche client
   * @param {string} id - ID de la fiche client
   * @param {Object} ficheData - Nouvelles données
   * @returns {Promise} - Fiche client mise à jour
   */
  async update(id, ficheData) {
    try {
      const response = await AxiosInstance.put(`/fiche-client/${id}`, ficheData);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la mise à jour de la fiche client:', error);
      throw error;
    }
  },

  /**
   * Supprimer une fiche client
   * @param {string} id - ID de la fiche client
   * @returns {Promise} - Confirmation de suppression
   */
  async delete(id) {
    try {
      const response = await AxiosInstance.delete(`/fiche-client/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la suppression de la fiche client:', error);
      throw error;
    }
  }
};

export default ficheClientService;

